import script from "./SignIntroduce.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignIntroduce.vue?vue&type=script&lang=ts&setup=true"

import "./SignIntroduce.vue?vue&type=style&index=0&id=0058185d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0058185d"]])

export default __exports__